export function analytics(action, label='null') {
	window.dataLayer.push({
		'event': 'Interactive',
		'category': 'Interactive',
		'action': action,
		'label': label
	});
	// console.clear();
	// console.table(window.dataLayer);
}